module.exports = __webpack_public_path__ + "static/img/img.f750b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.png
// module id = UBpp
// module chunks = 159